import moment from "moment";
import { postMessageToClient } from "../chatservice/communicationService";

const toTitleCase = (str: string) => {
    return str.replace( /\w\S*/g, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
}

const pickRandomString = (arr : string[]) => {
    var index = Math.floor(Math.random() * arr.length); 
    return arr[index];
}

const getOrdinalSuffix = (n: number) => {
    return["st","nd","rd"][((n+90)%100-10)%10-1]||"th"
}


const isMobileOS = () => {
    return (/Android|aarch64|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent))
}

const getUniqueId = (prefix:string, text: string) => {
    const textId = text?.split(' ')?.join('-')?.toLowerCase();
    return `${prefix?.toLowerCase()}-${textId}`;
}

const getWordCount = (text:string) => {
    if (text === null || text.length === 0) return 0;
    
    var words = text.split(' ');
    return words.length;
}

const getIntentGroupTypeId = (groupName:string) => {
    switch (groupName?.toLowerCase())
    {
        case "faq": return 1;
        case "livechat": return 2;
        case "welcome": return 3;
        case "firstsuggestions": return 4;
        case "ordertracking": return 5;
        case "storelocator": return 6;
        case "productavailability": return 7;
        case "menu": return 8;
        case "findawine": return 9;
        case "authenticate": return 10;
        case "ignore": return 0;
        default: return 0;
    }
}

const handleAnalyticsBot = (linkName: string, linkType: string, methodHandler:string ) => {
    const objCall = {
        data : {
            linkName : linkName,
            linkType: linkType,
        },
        methodHandler : methodHandler
    };
    postMessageToClient(objCall);
}

//function to get store trading hours status
const getStoreStatus = (storeData:any) => {
    const storeTradingStatus = {

         StatusBackground : "",
         StoreCurrentStatus :"",
         storeTradingHours : ""
    }
    if (storeData?.trading_hours_all[0]?.simpleTradingStatus === null) {
        storeTradingStatus.StatusBackground = "storeDetail__status-today-closed";
        storeTradingStatus.StoreCurrentStatus = "Closed now";

      let nextOpenDayIndex = storeData.trading_hours_all?.findIndex(
        (x: any) => x.simpleTradingStatus !== null
      );

      let data =storeData.trading_hours_all[nextOpenDayIndex]?.simpleTradingStatus[1]?.split(" ")[1].slice(0, 3);

      storeTradingStatus.storeTradingHours = `opens at ${storeData.trading_hours_all[nextOpenDayIndex]?.simpleTradingStatus[2]?.toUpperCase()}, ${data}`;
    } else {
      if (storeData.trading_hours_all[0]?.simpleTradingStatus[0]?.toLowerCase() === "closed now") {
        storeTradingStatus.StatusBackground = "storeDetail__status-today-closed";

        let storeTodayStartHour = storeData.trading_hours_all[0]?.simpleTradingStatus[1];
        let storeTodayStartDate = storeData.trading_hours_all[0]?.date?.split("T")[0];
        let storeTodayStartTime = new Date(storeTodayStartDate + " " + storeTodayStartHour).getTime();
        let currentTime = new Date().getTime();

        storeTradingStatus.StoreCurrentStatus = "Closed now";

        if (currentTime < storeTodayStartTime) {
            storeTradingStatus.storeTradingHours = `opens at ${storeData.trading_hours_all[0]?.simpleTradingStatus[1]?.toUpperCase()}`;
        } else {
          let nextOpenDayIndex = storeData.trading_hours_all?.findIndex(
            (x: any) => x.simpleTradingStatus !== null
          );

          let data = storeData.trading_hours_all[nextOpenDayIndex + 1]?.simpleTradingStatus[1]?.split(" ")[1].slice(0, 3);

          storeTradingStatus.storeTradingHours = `opens at ${storeData.trading_hours_all[1]?.simpleTradingStatus[2]}, ${data}`;
        }
      } else if (storeData.trading_hours_all[0]?.simpleTradingStatus[0]?.toLowerCase() === "closing soon") {
          storeTradingStatus.StoreCurrentStatus = "Closing soon" ;
          storeTradingStatus.StatusBackground = "storeDetail__status-closing-soon"
          storeTradingStatus.storeTradingHours = storeData.trading_hours_all[0]?.openHour?.toUpperCase();

      } else if (storeData.trading_hours_all[0]?.simpleTradingStatus[0]?.toLowerCase() === "opening soon") {
        storeTradingStatus.StoreCurrentStatus = "Opening soon" ;
        storeTradingStatus.StatusBackground = "storeDetail__status-opening-soon"
        storeTradingStatus.storeTradingHours = storeData.trading_hours_all[0]?.openHour?.toUpperCase();

      } else {
        storeTradingStatus.StoreCurrentStatus = "Open now" ;
        storeTradingStatus.StatusBackground = "storeDetail__status-today-open";
        storeTradingStatus.storeTradingHours = storeData.trading_hours_all[0]?.openHour?.toUpperCase();
      }
    }
    return storeTradingStatus;
  }

const isDeliveryDateToday = (value:string)=> {
  const deliveryDate = value?.split('T')[0];
  const todaysDate =  new Date();
  const todaysDateFormatted = moment(todaysDate).format('YYYY-MM-DD')
  return todaysDateFormatted === deliveryDate ? true : false
}

export { 
    toTitleCase,
    pickRandomString,
    getOrdinalSuffix,
    isMobileOS,
    getUniqueId,
    getWordCount,
    getIntentGroupTypeId,
    handleAnalyticsBot,
    getStoreStatus,
    isDeliveryDateToday
}